import { Routes } from "@angular/router";
import { RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/security/login/login.component";
import { AuthGuard } from "./interceptors/auth.guard";
import { ModuleComponent } from "./components/layout/module/module.component";
import { EntidadeComponent } from "./components/layout/entidade/entidade.component";
import { AcessoNegadoComponent } from "./components/acesso-negado/acesso-negado.component";
import { ExternalLoginComponent } from "./components/security/external-login/external-login.component";

export const ROUTES: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "acesso-negado",
        component: AcessoNegadoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "cadastro",
        loadChildren: () =>
          import("./modules/basico/basico.module").then((m) => m.BasicoModule),
      },
      {
        path: "seguranca",
        loadChildren: () =>
          import("./modules/seguranca/seguranca.module").then(
            (m) => m.SegurancaModule
          ),
      },
      {
        path: "servidor",
        loadChildren: () =>
          import("./modules/servidor/servidor.module").then(
            (m) => m.ServidorModule
          ),
      },
      {
        path: "folha",
        loadChildren: () =>
          import("./modules/folha/folha.module").then((m) => m.FolhaModule),
      },
      {
        path: "licenca",
        loadChildren: () =>
          import("./modules/licenca/licenca.module").then(
            (m) => m.LicencaModule
          ),
      },
      {
        path: "rescisao",
        loadChildren: () =>
          import("./modules/rescisao/rescisao.module").then(
            (m) => m.RescisaoModule
          ),
      },
      {
        path: "ferias",
        loadChildren: () =>
          import("./modules/ferias/ferias.module").then((m) => m.FeriasModule),
      },
      {
        path: "decimo",
        loadChildren: () =>
          import("./modules/decimo/decimo.module").then((m) => m.DecimoModule),
      },
      {
        path: "ocorrencia",
        loadChildren: () =>
          import("./modules/ocorrencia/ocorrencia.module").then(
            (m) => m.OcorrenciaModule
          ),
      },
      {
        path: "banco",
        loadChildren: () =>
          import("./modules/banco/banco.module").then((m) => m.BancoModule),
      },
      {
        path: "esocial",
        loadChildren: () =>
          import("./modules/esocial/esocial.module").then(
            (m) => m.ESocialModule
          ),
      },
      {
        path: "obrigacoes",
        loadChildren: () =>
          import("./modules/obrigacoes/obrigacoes.module").then(
            (m) => m.ObrigacoesModule
          ),
      },
      {
        path: "utilitarios",
        loadChildren: () =>
          import("./modules/utilitario/utilitario.module").then(
            (m) => m.UtilitarioModule
          ),
      },
      {
        path: "portal-servidor",
        loadChildren: () =>
          import("./modules/portal-servidor/portal-servidor.module").then(
            (m) => m.PortalServidorModule
          ),
      },
      {
        path: "autonomo",
        loadChildren: () =>
          import("./modules/autonomo/autonomo.module").then(
            (m) => m.AutonomoModule
          ),
      },
      {
        path: "transparencia",
        loadChildren: () =>
          import("./modules/transparencia/transparencia.module").then(
            (m) => m.TransparenciaModule
          ),
      },
      {
        path: "consulta-view",
        loadChildren: () =>
          import("./modules/consulta-view/consulta-view.module").then(
            (m) => m.ConsultaViewModule
          ),
      },
      {
        path: "previdencia",
        loadChildren: () =>
          import("./modules/previdencia/previdencia.module").then(
            (m) => m.PrevidenciaModule
          ),
      },
      {
        path: "documentos",
        loadChildren: () =>
          import("./modules/documentos/documentos.module").then(
            (m) => m.DocumentosModule
          ),
      },
      {
        path: "notificacoes",
        loadChildren: () =>
          import("./modules/notificacao/notificacao.module").then(
            (m) => m.NotificacaoModule
          ),
      },
    ],
  },
  { path: "login", component: LoginComponent },
  { path: "login/:id", component: LoginComponent },
  { path: "login/:user/:token", component: ExternalLoginComponent },
  { path: "modulo", component: ModuleComponent },
  { path: "entidade", component: EntidadeComponent },
];

export const routes: ModuleWithProviders = RouterModule.forRoot(ROUTES);
